import React from 'react';
import { Button, Modal } from '../../../../Components/uielements';
import { ErrorSvg, SuccessSvg } from '../../../../Components/icons';
import { ModalButtonWrapper } from '../../../../services/settings/appStyle/global.style';
import { ContentWrapper, MessageTitle } from '../broadCast.style';

const Success = ({ onClose }) => {
  return (
    <ContentWrapper>
      <MessageTitle>
        <SuccessSvg style={{ width: '100px', height: '100px' }} />
        The Notification has been completed successfully.
      </MessageTitle>{' '}
      <ModalButtonWrapper>
        <Button varient="normal" onClick={onClose}>
          Close
        </Button>
      </ModalButtonWrapper>
    </ContentWrapper>
  );
};

const Error = ({ onClose }) => {
  return (
    <ContentWrapper>
      <MessageTitle>
        <ErrorSvg style={{ width: '100px', height: '100px' }} />
        The Notification encountered an issue. Please try again later.
      </MessageTitle>{' '}
      <ModalButtonWrapper>
        <Button varient="normal" onClick={onClose}>
          Close
        </Button>
      </ModalButtonWrapper>
    </ContentWrapper>
  );
};

const BroadCastInfoModal = ({ onClose, isError, isSuccess }) => {
  return (
    <Modal isOpen={true} title="Add new member" isHeader={false}>
      {isSuccess && <Success onClose={onClose} />}
      {isError && <Error onClose={onClose} />}
    </Modal>
  );
};

export default BroadCastInfoModal;
